import Storage from 'good-storage'
import Config from '../config/app.js'

export function getShopId() {
    return Storage.session.get('shopId')
}
export function setShopId(shopId) {
    return Storage.session.set('shopId', shopId)
}
export function setNewSession(newSession) {
    return Storage.session.set('newSession', newSession)
}
export function getNewSession() {
    return Storage.session.get('newSession')
}
export function getToken() {
    return Storage.session.get(Config.tokenKey)
}
export function setToken(token) {
    return Storage.session.set(Config.tokenKey, token)
}
export function removeToken() {
    return Storage.session.remove(Config.tokenKey)
}
export function setMember(member) {
    return Storage.session.set('member', member)
}
export function getMember() {
    return Storage.session.get('member')
}
export function removeMember() {
    return Storage.session.remove('member')
}
export function setShopMemberId(shopMemberId) {
    return Storage.session.set('shopMemberId', shopMemberId)
}
export function getShopMemberId() {
    return Storage.session.get('shopMemberId')
}
export function removeShopMemberId() {
    return Storage.session.remove('shopMemberId')
}


export function isLogin() {
    return (getToken() || '').length > 5
}

export function hasPromission(code) {
    return true;
}

let cache = {};
export function cacheServerData(key, request) {
    var promise = new Promise((resolve, reject) => {
        var data = cache[key]
        if (data) resolve(data);
        else {
            request().then((d) => {
                cache[key] = d;
                data = d;
                resolve(data);
            }).catch(() => {
                reject()
            })
        }
    })
    return promise;
}